import { Card } from "@/components/ui/card";
import { ChevronRight, ClipboardList, MessageSquareReply } from "lucide-react";
import { DAILY, TaskCategoryLabel } from "./shared";

const latestDaily = (t) => {
  const ds = t.daily_status || [];
  if (!ds.length) return null;
  return ds[ds.length - 1].status;
};
const isCompleted = (t) => t.status === "approved" || latestDaily(t) === "done";
const hasReview = (t) => (t.feedback || []).some((f) => f.rating || f.review_comment || f.review_result);

export default function TasksView({ tasks, nav }) {
  const completed = tasks.filter(isCompleted).length;
  return (
    <div data-testid="parent-tasks">
      <h1 className="font-heading text-3xl font-bold tracking-tight text-slate-900">Bu Haftaki Görevler</h1>
      <p className="mt-1 text-sm text-slate-500">{tasks.length} görev · {completed} tamamlandı</p>

      <div className="mt-5 space-y-3">
        {tasks.map((t) => {
          const cur = latestDaily(t);
          return (
            <button key={t.id} data-testid={`parent-task-${t.id}`} onClick={() => nav.goSub({ type: "task", id: t.id })}
              className="block w-full rounded-2xl bg-white p-4 text-left shadow-[0_2px_10px_rgba(0,0,0,0.05)] transition-transform active:scale-[0.99]">
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0 flex-1">
                  <TaskCategoryLabel name={t.task?.area} className="mb-1.5" />
                  <h3 className="font-heading font-semibold leading-snug text-slate-900">{t.task?.title}</h3>
                </div>
                <ChevronRight className="mt-0.5 h-5 w-5 flex-shrink-0 text-slate-300" />
              </div>
              {t.task?.description && <p className="mt-1 line-clamp-2 text-sm text-slate-500">{t.task.description}</p>}
              <div className="mt-3 flex flex-wrap gap-2">
                {Object.entries(DAILY).map(([k, v]) => {
                  const active = cur === k;
                  return (
                    <span key={k} className={`inline-flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-xs font-semibold ${active ? v.solid : "bg-slate-50 text-slate-500"}`}>
                      <span className={`flex h-4 w-4 items-center justify-center rounded-full ${active ? "bg-white" : v.dot}`}><v.Icon className={`h-2.5 w-2.5 ${active ? v.iconText : "text-white"}`} strokeWidth={3} /></span>
                      {v.label}
                    </span>
                  );
                })}
              </div>
              {hasReview(t) && (
                <p className="mt-3 inline-flex items-center gap-1.5 text-sm font-medium text-violet-600" data-testid={`task-has-review-${t.id}`}>
                  <MessageSquareReply className="h-4 w-4" /> Öğretmen geri bildirimi var
                </p>
              )}
            </button>
          );
        })}
        {tasks.length === 0 && (
          <Card className="rounded-2xl border-dashed p-14 text-center text-slate-400"><ClipboardList className="mx-auto mb-3 h-9 w-9 text-slate-300" />Atanmış görev yok.</Card>
        )}
      </div>
    </div>
  );
}
